import React, { useEffect, useRef, useState } from "react";
import "../styles/SpeechControls.css";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import VolumeOffIcon from "@mui/icons-material/VolumeOff";

const betsyLogo = "/img/kcgbetsy/Betsy.png";

const BetsySpeechControls = ({text}) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef(null);

  // Play/Pause Toggle
  const handlePlayPause = () => {
    const audio = audioRef.current;
    if (!audio) return;

    if (audio.paused) {
      // Pause all other players
      window.dispatchEvent(new Event("stopAllAudio"));
      audio.play();
      setIsPlaying(true);
    } else {
      audio.pause();
      audio.currentTime = 0;
      setIsPlaying(false);
    }
  };

  useEffect(() => {
    const audio = audioRef.current;

    // Handler to pause when another audio plays
    const stopAudio = () => {
      if (!audio.paused) {
        audio.pause();
        audio.currentTime = 0;
        setIsPlaying(false);
      }
    };

    // Auto-reset UI on audio end
    const resetOnEnd = () => {
      setIsPlaying(false);
    };

    // Cleanup on refresh
    const stopOnUnload = () => {
      audio.pause();
      audio.currentTime = 0;
      setIsPlaying(false);
    };

    window.addEventListener("stopAllAudio", stopAudio);
    window.addEventListener("beforeunload", stopOnUnload);
    audio.addEventListener("ended", resetOnEnd);

    return () => {
      window.removeEventListener("stopAllAudio", stopAudio);
      window.removeEventListener("beforeunload", stopOnUnload);
      audio.removeEventListener("ended", resetOnEnd);
    };
  }, []);

  return (
    <>
      {isPlaying ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "4px",
          }}
        >
          <img src={betsyLogo} alt="Betsy" className="betsylogosize wave" />
          <div
            onClick={handlePlayPause}
            style={{ color: "#000", cursor: "pointer" }}
          >
            <VolumeUpIcon fontSize="medium" />
          </div>
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            gap: "4px",
          }}
        >
          <img src={betsyLogo} alt="Betsy" className="betsylogosize" />
          <div
            onClick={handlePlayPause}
            style={{ color: "#000", cursor: "pointer" }}
          >
            <VolumeOffIcon fontSize="medium" />
          </div>
        </div>
      )}
      <audio ref={audioRef} src={text} preload="auto" />
    </>
  );
};

export default BetsySpeechControls;
